<template>
  <div>
    <el-row type="flex" class="row-bg" justify="space-between">
      <el-col :span="2">
        <YearsComponent @change="onYearChange" />
      </el-col>
      <el-col :span="4">
        <rabbey-toolbox :filterables="true" @filter-search="handleSearch">
        </rabbey-toolbox>
      </el-col>
    </el-row>
    <rabbey-table-3
      :loading="loadingData"
      :data="TableData"
      :columns="TableColumns"
      :search="filters.search"
    />
  </div>
</template>

<script>
import columns from "@/columns/ElectronicComprobantReport/ColumnsElectronicComprobantsByMonths";
import YearsComponent from "@/components/Global_System/YearsComponent";

const actualYear = new Date().getFullYear();

export default {
  name: "ElectronicComprobantEmitedByMonth",
  components: {
    YearsComponent
  },
  data() {
    return {
      TableData: [],
      TableColumns: columns,
      loadingData: false,
      filters: {
        year: actualYear,
        search: ""
      }
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loadingData = true;
      try {
        // Simulate an API call to fetch data
        await this.$http
          .get("api/accountsReceivable/ElectronicComprobantsByMonthsReport", {
            params: {
              year: this.filters.year
            }
          })
          .then((response) => {
            this.TableData = response.data;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {});
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loadingData = false;
      }
    },
    async onYearChange(val) {
      this.filters.year = val;
      await this.fetchData();
    },
    handleSearch(query) {
      this.filters.search = query;
    }
  }
};
</script>

<style lang="scss" scoped></style>
